import request from "@/utils/request";
/**
 * 获取课程合辑详情
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getCollectionDetailApi(data) {
  return request({
    url: "product/course/detail-collection",
    data: data,
    method: "post",
  });
}
